import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { About } from "@/components/site/About";
import { Differentiators } from "@/components/site/Differentiators";
import { Experiences } from "@/components/site/Experiences";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { WhatsAppButton } from "@/components/site/WhatsAppButton";

export default function Home() {
  return (
    <div data-testid="home-page" className="relative min-h-screen bg-[#faf6ef]">
      <Header />
      <main>
        <Hero />
        <About />
        <Differentiators />
        <Experiences />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
